import React from 'react';
import { Box, Typography, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Chip, Backdrop } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation, useNavigate } from 'react-router-dom';
import { pillars } from './navConfig';
import { RAIL_WIDTH } from './IconRail';

const FLYOUT_WIDTH = 240;

export default function FlyoutPanel({ pillarId, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();
  const pillar = pillars.find((p) => p.id === pillarId);

  if (!pillar) return null;

  const handleNav = (path) => {
    navigate(path);
    onClose();
  };

  return (
    <>
      <Backdrop open sx={{ zIndex: 1199 }} onClick={onClose} />
      <Box
        sx={{
          position: 'fixed',
          left: RAIL_WIDTH,
          top: 0,
          width: FLYOUT_WIDTH,
          height: '100vh',
          bgcolor: 'background.paper',
          borderRight: 1,
          borderColor: 'divider',
          zIndex: 1200,
          display: 'flex',
          flexDirection: 'column',
          boxShadow: (theme) =>
            theme.palette.mode === 'dark'
              ? '4px 0 24px rgba(0,0,0,0.3)'
              : '4px 0 24px rgba(0,0,0,0.08)',
          transform: 'translateX(0)',
          transition: 'transform 150ms ease',
        }}
      >
        {/* Header */}
        <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="subtitle2" sx={{ color: pillar.colorHex, fontWeight: 600 }}>
              {pillar.label}
            </Typography>
            <Chip
              label={pillar.shortLabel}
              size="small"
              sx={{
                mt: 0.5,
                height: 20,
                fontSize: '0.65rem',
                fontWeight: 700,
                bgcolor: pillar.colorHex + '1a',
                color: pillar.colorHex,
              }}
            />
          </Box>
          <IconButton size="small" onClick={onClose} sx={{ color: 'text.secondary' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Nav items */}
        <List dense sx={{ px: 1, flex: 1 }}>
          {pillar.items.map((item) => {
            const active = location.pathname === item.path;
            return (
              <ListItemButton
                key={item.id}
                onClick={() => handleNav(item.path)}
                sx={{
                  borderRadius: 1.5,
                  mb: 0.25,
                  borderLeft: active ? `2px solid ${pillar.colorHex}` : '2px solid transparent',
                  bgcolor: active ? pillar.colorHex + '15' : 'transparent',
                  '&:hover': { bgcolor: pillar.colorHex + '0d' },
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, color: active ? pillar.colorHex : 'text.secondary' }}>
                  <item.icon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    variant: 'body2',
                    fontWeight: active ? 600 : 400,
                    color: active ? pillar.colorHex : 'text.secondary',
                  }}
                />
              </ListItemButton>
            );
          })}
        </List>
      </Box>
    </>
  );
}
